import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import { CLOSURE_GRACE_DAYS } from '../../../../components/company-closure/companyClosure';

/**
 * StartCompanyClosureDialog - Confirmação de "Iniciar encerramento" (Admin Geral)
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {{ name: string }} props.company
 * @param {boolean} props.loading
 * @param {Function} props.onConfirm
 * @param {Function} props.onCancel
 */
function StartCompanyClosureDialog({ isOpen, company, loading, onConfirm, onCancel }) {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      title="Iniciar encerramento da conta"
      variant="warning"
      confirmLabel="Iniciar encerramento"
      cancelLabel="Cancelar"
      onConfirm={onConfirm}
      onCancel={onCancel}
      loading={loading}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary' }}>
          {company?.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          A conta entra em carência de {CLOSURE_GRACE_DAYS} dias. Os responsáveis recebem um e-mail
          agora e lembretes antes do prazo, e a conta é mantida se alguém
          assinar um plano.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Nada é apagado automaticamente: depois da carência, a eliminação dos dados é feita
          manualmente aqui, com o arquivo de segurança já gerado.
        </Typography>
      </Box>
    </ConfirmDialog>
  );
}

export default StartCompanyClosureDialog;
